import React, { useEffect, useState } from 'react';
import { FlexColumnDiv } from '../style';
import { VisitAttributeRowDiv } from './components';
import { VisitAttributeMenu } from './VistAttributeMenu';
import { VisitAttributeCheckboxes } from './VisitAttributeCheckboxes';
export const VisitAttributeSelectors = ({
  visitAttributes,
  anchor,
  onSubmit,
  appVisit,
  resetAttributes
}) => {
  const [visitAttributesChanged, setVisitAttributesChanged] = useState(null);
  const [selectableVisitAttributes, setSelectableVisitAttributes] = useState([]); // when component is created, make sure the selectable visitattributes are set to
  // stored state or isSelected = false.

  useEffect(() => {
    if (appVisit && appVisit.visitAttributes) {
      visitAttributes && visitAttributes.forEach(sAttribute => {
        if (sAttribute) sAttribute.isSelected = appVisit.visitAttributes.find(att => sAttribute.id === att.id).isSelected;
      });
    } else if (resetAttributes) {
      visitAttributes && visitAttributes.forEach(sAttribute => {
        if (sAttribute) sAttribute.isSelected = false;
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);

  const sortVisitAttributes = (item1, item2) => {
    if (((item1 === null || item1 === void 0 ? void 0 : item1.name) || '') < ((item2 === null || item2 === void 0 ? void 0 : item2.name) || '')) return -1;else if (((item1 === null || item1 === void 0 ? void 0 : item1.name) || '') > ((item2 === null || item2 === void 0 ? void 0 : item2.name) || '')) return 1;
    return 0;
  };

  useEffect(() => {
    if (visitAttributes) {
      setSelectableVisitAttributes(visitAttributes.filter(va => va && va.selectable && va.uiavailable).sort(sortVisitAttributes));
    }
  }, [visitAttributes, visitAttributesChanged]);

  const handleVisitAttributeSelectedChange = (visitAttribute, checked) => {
    if (visitAttributes) {
      let visitAttrib = visitAttributes.find(va => va.id === visitAttribute.id);

      if (!visitAttrib) {
        visitAttrib = {
          id: visitAttribute.id,
          isSelected: checked,
          name: visitAttribute.name,
          selectable: visitAttribute.selectable,
          uiavailable: visitAttribute.uiavailable,
          shortname: visitAttribute.shortname
        };
      }

      visitAttrib.isSelected = checked;
      setVisitAttributesChanged(!visitAttributesChanged);
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FlexColumnDiv, null, /*#__PURE__*/React.createElement(VisitAttributeRowDiv, null, anchor ? /*#__PURE__*/React.createElement(VisitAttributeMenu, {
    anchor: anchor,
    attributes: selectableVisitAttributes,
    onSubmit: onSubmit,
    handleAttributeChange: handleVisitAttributeSelectedChange
  }) : /*#__PURE__*/React.createElement(VisitAttributeCheckboxes, {
    attributes: selectableVisitAttributes,
    handleAttributeChange: handleVisitAttributeSelectedChange
  }))));
};